import { Grid2, Typography, Link, Divider } from "@mui/material";
import { legalTermsSchema } from "../enum/formEnum";
import urlConstant from "../../constants/urlConstants";

const LegalTermsDetail = ({ formData }) => {
  return (
    <>
      <Typography variant="h4" color="default.main">
        Legal Terms & Agreements
      </Typography>

      <Grid2 container spacing={3} mt={3}>
        {legalTermsSchema.map((section) => {
          let value = formData?.[section.key]?.[section.fieldKey];

          if (
            !value &&
            section?.key === "overtimeAgreement" &&
            Boolean(formData?.paymentDetailsSection0?.overtimeAgreement) ===
              true
          ) {
            value = Boolean(
              formData?.paymentDetailsSection0?.overtimeAgreement
            );
          }

          const aggreementText =
            section?.key === "obligationOfResponsibleParty"
              ? "Responsible Party Obligation"
              : section.title;
          return (
            <Grid2 size={{ xs: 12, sm: 12 }} key={section.key}>
              {/* Section Title */}
              <Typography variant="h6" color="default.main" gutterBottom>
                {section.title}
              </Typography>

              {/* Description */}
              {section.key !== "arbitration" && section.description && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  paragraph
                  sx={{ whiteSpace: "pre-line" }}
                >
                  {section.description}
                </Typography>
              )}

              {section.key === "clientServicePlanAcknowledgement" && (
                <Grid2 item xs={12} sm={12}>
                  <Grid2 container spacing={10}>
                    {/* Signature of Client or Client Contact */}
                    <Grid2 item xs={12} sm={6} mb={2}>
                      <Typography variant="body2" color="default.main" mb={0.5}>
                        Signature of Client or Client Contact
                      </Typography>

                      {value?.clientSignatureAndContactInfo
                        ?.signatureOfClient ? (
                        <img
                          src={
                            value.clientSignatureAndContactInfo
                              .signatureOfClient
                          }
                          alt="Signature of Client or Client Contact"
                          style={{ maxWidth: "100%", maxHeight: "200px" }}
                        />
                      ) : (
                        <Typography variant="body1" color="default.light">
                          No signature provided
                        </Typography>
                      )}
                    </Grid2>

                    {/* Date */}
                    <Grid2 item xs={12} sm={6} mb={2}>
                      <Typography variant="body2" color="default.main" mb={0.5}>
                        Date
                      </Typography>
                      <Typography variant="body1" color="default.light">
                        {value?.date
                          ? new Date(value.date).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            })
                          : "-"}
                      </Typography>
                    </Grid2>
                  </Grid2>

                  {/* Printed Name of Client/Client Contact */}
                  <Grid2 item xs={12} sm={12} mb={2}>
                    <Typography variant="body2" color="default.main" mb={0.5}>
                      Printed Name of Client/Client Contact
                    </Typography>
                    <Typography variant="body1" color="default.light">
                      {value?.printedClientName || "-"}
                    </Typography>
                  </Grid2>

                  {/* Agency Representative */}
                  <Grid2 container xs={12} sm={6}>
                    <Grid2 item xs={6} sm={6} mb={2}>
                      <img
                        src={urlConstant.SignImage.ErnieSignImageUrl}
                        alt="Agency Representative"
                        style={{ maxWidth: "80%", maxHeight: "200px" }}
                      />
                      <Divider sx={{ borderBottomWidth: 2, maxWidth: "80%" }} />
                      <Typography
                        variant="body2"
                        color="default.main"
                        mb={0.5}
                        sx={{ whiteSpace: "pre-line" }}
                      >
                        {
                          "Ernie Cote\nChief Operating Officer\nAgency Representative"
                        }
                      </Typography>
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}

              {/* Special case: Arbitration & Jury Trial Waiver extra UI */}
              {section.key === "arbitration" && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  paragraph
                  sx={{ whiteSpace: "pre-line" }}
                >
                  All disputes regarding any aspect of this Engagement
                  Agreement, including, without limitation, enforcement or
                  interpretation of this Agreement, recovery of any amount due
                  hereunder, or any claim for injury, harm or damage in any way
                  associated with any goods or services provided hereunder,
                  shall be subject to determination by binding arbitration under
                  the rules of the American Arbitration Association and any such
                  arbitration shall be conducted in Dallas County, Texas, in
                  accordance with Texas law, except for its conflicts of laws
                  principles.
                  <b>
                    THE PARTIES HEREBY WAIVE AND AGREE NOT TO INVOKE ANY
                    STATUTORY, CONSTITUTIONAL OR COMMON LAW RIGHT TO A TRIAL BY
                    JURY REGARDLESS OF WHETHER SUCH RIGHT ARISES UNDER STATE OR
                    FEDERAL LAW.
                  </b>
                </Typography>
              )}

              {/* Special case: Privacy Consent extra UI */}
              {section.key === "privacyConsent" && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  paragraph
                  sx={{ whiteSpace: "pre-line" }}
                >
                  I agree with the storage and handling of my data by this
                  website found at{" "}
                  <Link
                    href="https://cambridgecaregivers.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://cambridgecaregivers.com/privacy-policy/
                  </Link>
                  .
                </Typography>
              )}

              {/* Agreement Result */}
              {section.key !== "clientServicePlanAcknowledgement" && (
                <Typography variant="body1" color="secondary.dark">
                  {value === true
                    ? section.agreementText
                    : `No, I do not agree to the ${aggreementText} terms`}
                </Typography>
              )}
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};

export default LegalTermsDetail;
